import { render, staticRenderFns } from "./LocalizedUrl.vue?vue&type=template&id=3444c562&"
import script from "./LocalizedUrl.vue?vue&type=script&lang=js&"
export * from "./LocalizedUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports